import {SpecialOffersTranslations} from '../typing/translations';
import {useInventory} from './use-inventory';

export function useTranslations(): SpecialOffersTranslations {
  return useInventory().translations;
}
